export const courseLessonTypes = {
   article: 'article',
   tutorial: 'tutorial',
   checklist: 'checklist',
};
